module.exports = __webpack_public_path__ + "static/media/student23.33cce482.png";